<template>
  <div class="checkout">
    <h2>Order Received</h2>
    <div class="mb-4">Thank you for your order! Your order confirmation number is <strong>#{{order.id + $consts.ORDER_NUM_BASE}}.</strong></div>
    <loading-panel :loading="isLoading">
      <div v-if="!order">Unable to find data for this order.</div>
      <div v-else>
        <h4>Order Summary</h4>
        <table class="w-100 table table-striped">
          <tbody>
            <tr v-for="(option, i) in order.checkout_option_responses" :key="`line-item-${i}`">
              <!-- Item name -->
              <td>{{option.checkout_option.label}}</td>
              <!-- Item count -->
              <td v-if="!option.nodeTypesJsonSnapshot">
                <!-- if the option is not per-node in nature, it's count is 1 -->
                x1
              </td>
              <td
                v-else
              >x{{getApplicableNodeCount(option)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </loading-panel>
    <error-panel :errors="errors"></error-panel>

    <div class="text-center mt-2 py-2">
      <router-link class="btn" to="/purchase">Done</router-link>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  name: "checkout",
  components: {},
  data: () => ({
    isLoading: false,
    errors: [],
    order: null,
    typedNodes: []
  }),
  methods: {
    getApplicableNodeCount(option) {
      let applicableNodeTypes = JSON.parse(option.nodeTypesJsonSnapshot);

      let total = 0;
      applicableNodeTypes.forEach(type => {
        total += this.typedNodes.filter(node => node.node.type == type).length;
      });

      return total;
    }
  },
  computed: {},
  async mounted() {
    this.$storage.remove("option-selections");
    this.$storage.remove("cart");

    try {
      this.isLoading = true;

      // Request the order details using the Stripe Session ID
      const response = await this.$web.getOrderByConfirmation(
        this.$route.params.sessionId
      );

      this.order = response.data.order;
      this.typedNodes = response.data.typedNodes;
    } catch (e) {
      console.log("Error: ", e);
    } finally {
      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout {
  margin: auto;
  margin-top: 15px;
  max-width: 360px;

  @media screen and (min-width: 768px + 250px + 50px) {
    max-width: 768px;
  }
}

.option-group {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
